
import i18n from '@/i18n'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/shadcn/tooltip'
import { iconForName } from '@/components/common/iconByName'

/**
 * For action modules without an uploaded image the backend provides an `iconName`
 * (lowercase, sometimes with spaces). We map it to a lucide icon; unknown/missing
 * names fall back to `Zap`.
 */

/**
 * Small inline icon (no border/tooltip) for lists like the groups dialog:
 * uploaded image (iconUrl), otherwise the lucide icon mapped from iconName.
 * Counterpart to `ShopModuleTypeIcon`.
 */
export function ActionModuleTypeIcon({
                                       module,
                                       className = 'size-4 text-muted-foreground',
                                     }: {
  module: { iconUrl?: string | null; iconName?: string | null; colorHex?: string | null }
  className?: string
}) {
  if (module.iconUrl) {
    return <img src={module.iconUrl} alt="" className={`${className} object-contain`} />
  }
  const FallbackIcon = iconForName(module.iconName)
  return <FallbackIcon className={className} style={module.colorHex ? { color: module.colorHex } : undefined} />
}

/**
 * Action module in the table: uploaded image (iconUrl), otherwise the lucide icon
 * mapped from iconName, otherwise the fallback icon. Tooltip shows the module name.
 */
export function ActionModuleIcon({ module }: {
  module: {
    name?: string | null
    iconName?: string | null
    iconUrl?: string | null
    colorHex?: string | null
  }
}) {
  const name = module.name ?? i18n.t('dialog.actionModules.fallbackName', { ns: 'groups' })
  const FallbackIcon = iconForName(module.iconName)
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="flex size-8 items-center justify-center overflow-hidden rounded-md border bg-muted/40 text-foreground">
          {module.iconUrl ? (
            <img src={module.iconUrl} alt="" className="size-full object-contain" />
          ) : (
            <FallbackIcon className="size-4" style={module.colorHex ? { color: module.colorHex } : undefined} />
          )}
        </span>
      </TooltipTrigger>
      <TooltipContent>{name}</TooltipContent>
    </Tooltip>
  )
}
